import { DateIntervalForm as FilterComponent } from 'components/shared/DateIntervalForm'
export default FilterComponent
